<template>
  <v-select
      multiple
      v-model="model"
      :options="allMonetaryActions"
      :reduce="m=>m.value"
      v-bind="selectProps"
      :placeholder="placeholder"
  />
</template>

<script>
export default {
  name: 'MonetaryActionSelectBox',
  props: {
    value: {
      required: false,
    },
    selectProps:{
      default: () => ({})
    },
    disabled:{
      type: Boolean,
      default: () => false
    },
    clearable:{
      type: Boolean,
      default: () => false
    },
    multiple:{
      type: Boolean,
      default: () => false
    },
    placeholder:{
      type: String,
      default: () => ''
    }
  },
  computed:{
    model:{
      get(){
        return this.value;
      },
      set(value){
        this.$emit('input',value);
      }
    },
    allMonetaryActions(){
      let actions = this.$t('monetaryActions');
      return Object.keys(actions).map(key => ({
        label: actions[key].name,
        value: key
      }));
    },
    _selectProps(){
      let props = {...this.$props, ...this.selectProps}
      delete props.value
      delete props.options
      delete props.label
      delete props.reduce
      return props
    }
  }
};
</script>

<style scoped>

</style>
